/* eslint-disable prefer-rest-params */

function throttle(func, limit) {
  let wait = false;
  return function () {
    const args = arguments;
    const context = this;
    if (!wait) {
      func.apply(context, args);
      wait = true;
      setTimeout(() => (wait = false), limit);
    }
  };
}

export default throttle;



// WEBPACK FOOTER //
// ./scripts/util/throttle.js